export default interface NewsData
{
    // ニュースの種類
    type: number,
    // 更新日
    releaseDate: string,
    // リンク先URL
    url: string,
    // ニュース本文
    text: string,
};

export function getNewsCategoryName(num: number)
{
    switch(num){
        case 1: return "コンテンツ";
        case 2: return "WEB3";
        case 3: return "クリエイター";
        default: return "";
    }
}

export function getDataCategory(num: number)
{
    switch(num){
        case 1: return "product";
        case 2: return "web3";
        case 3: return "ugc";
        default: return "";
    }
}